import { render, staticRenderFns } from "./SideBets.vue?vue&type=template&id=25538f05&"
import script from "./SideBets.vue?vue&type=script&lang=js&"
export * from "./SideBets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports